const logActionsMiddleware = (/*store*/) => (next) => (action) => {

  Logger.log('REDUX:', action.type, action);

  return next(action);
}

export default logActionsMiddleware;
